import { Clock16, CallOrder16, Support16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './phonesOpenedInfo.css';

interface IPhonesOpenedInfoProps {
  phones: React.ReactElement;
  schedule: string | null;
  availability: string | null;
  calltracking: string | null;
  feedback: React.ReactElement;
}
export const PhonesOpenedInfo = ({
  phones,
  schedule,
  availability,
  calltracking,
  feedback,
}: IPhonesOpenedInfoProps) => {
  return (
    <div className={styles['container']} id="asidePhonesOpenedInfo">
      {phones}
      <div className={styles['description']}>
        {availability && (
          <div className={styles['info']}>
            <div className={styles['icon']}>
              <Clock16 />
            </div>
            <span>{availability}</span>
          </div>
        )}
        {schedule && (
          <div className={styles['info']}>
            <div className={styles['icon']}>
              <Clock16 />
            </div>
            <span>{schedule}</span>
          </div>
        )}
        {calltracking && (
          <div className={styles['info']}>
            <div className={styles['icon']}>
              <CallOrder16 />
            </div>
            <span>{calltracking}</span>
          </div>
        )}
        {feedback && (
          <div className={styles['info']}>
            <div className={styles['icon']}>
              <Support16 />
            </div>
            <span>{feedback}</span>
          </div>
        )}
      </div>
    </div>
  );
};
